export default __webpack_public_path__ + "static/media/ico-sq-6-water.5936d3bc.svg";